import { io } from 'socket.io-client';

const socketOptions = {
  transports: ['websocket'],
  path: '/socket.io',
  withCredentials: true
};

/**
 * Creates a new socket connection.
 * Always call this within a `useEffect` and manage `.on` / `.off` manually.
 */
export const createSocket = () => {
  return io(process.env.REACT_APP_API_URL, socketOptions);
};
